var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.0938C6.99041 10.0938 4.94791 8.05126 4.94791 5.54168C4.94791 3.03209 6.99041 0.989594 9.5 0.989594C12.0096 0.989594 14.0521 3.03209 14.0521 5.54168C14.0521 8.05126 12.0096 10.0938 9.5 10.0938ZM9.5 2.17709C7.6475 2.17709 6.13541 3.68918 6.13541 5.54168C6.13541 7.39418 7.6475 8.90626 9.5 8.90626C11.3525 8.90626 12.8646 7.39418 12.8646 5.54168C12.8646 3.68918 11.3525 2.17709 9.5 2.17709Z",
    fill: "#00a14b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3005 18.0104C15.976 18.0104 15.7068 17.7412 15.7068 17.4167C15.7068 14.6854 12.9201 12.4687 9.50012 12.4687C6.08012 12.4687 3.29346 14.6854 3.29346 17.4167C3.29346 17.7412 3.02429 18.0104 2.69971 18.0104C2.37512 18.0104 2.10596 17.7412 2.10596 17.4167C2.10596 14.0362 5.42304 11.2812 9.50012 11.2812C13.5772 11.2812 16.8943 14.0362 16.8943 17.4167C16.8943 17.7412 16.6251 18.0104 16.3005 18.0104Z",
    fill: "#00a14b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9712da43e7297bf7b7d90af3fa097f2e.svg";
export { ForwardRef as ReactComponent };